const chartPalette = [
  { hex: '#637eff', variable: 'indigo' },
  { hex: '#3abefa', variable: 'aqua' },
  { hex: '#1dc463', variable: 'green' },
  { hex: '#fca000', variable: 'yellow' },
  { hex: '#c363e5', variable: 'purple' },
];

export const stages = [
  {
    accent: chartPalette[0],
    key: 'visitors',
    label: 'Visits',
    tooltip:
      'Companies who have appeared in Clearbit Audiences and have visited your website',
  },
  {
    accent: chartPalette[1],
    key: 'leads',
    label: 'Leads',
    tooltip: 'Leads tooltip content goes here',
  },
  {
    accent: chartPalette[2],
    key: 'mqls',
    label: 'MQLs',
    tooltip: 'MQLs tooltip content goes here',
  },
  {
    accent: chartPalette[3],
    key: 'opportunities',
    label: 'Opportunities',
    tooltip: null,
  },
  {
    accent: chartPalette[4],
    key: 'dealsWon',
    label: 'Deals won',
    tooltip: null,
  },
];
